import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { appReducer } from '../../features/app/appSlice';
import { langReducer } from '../lang/langSlice';
import { tokenHandlingReducer } from '../tokenHandling/tokenHandlingSlice';
import { loginReducer } from '../login/loginSlice';
import { usersApi } from '../../features/app/services/usersApi';
import { accountsApi } from '../../features/app/services/accountsApi';

export const rootReducer = combineReducers({
    app: appReducer,
    lang: langReducer,
    login: loginReducer,
    tokenHandling: tokenHandlingReducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [accountsApi.reducerPath]: accountsApi.reducer,
});

export const setupStore = (preloadedState?: Partial<RootState>) =>
    configureStore({
        reducer: rootReducer,
        middleware: getDefaultMiddleware => getDefaultMiddleware().concat(usersApi.middleware, accountsApi.middleware),
        preloadedState: preloadedState,
    });

export const store = setupStore();

// Infer the `RootState` and `RootDispatch` types from the store itself
export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
